import React from 'react';

import { Container } from './styles';

const PageHeader: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default PageHeader;
